<template>
    <div class="visualization">
        <main-screen v-if="showType == 0" @switchType="switchType"></main-screen>
        <o-b-d v-if="showType == 1" @switchType="switchType"></o-b-d>
        <dual-camera v-if="showType == 2" @switchType="switchType"></dual-camera>
        <single-camera v-if="showType == 3" @switchType="switchType"></single-camera>
    </div>
</template>
<script>
import MainScreen from '@/components/largeScreen/MainScreen.vue';
import OBD from '@/components/largeScreen/OBD.vue';
import DualCamera from '@/components/largeScreen/DualCamera.vue';
import SingleCamera from '@/components/largeScreen/SingleCamera.vue';

export default {
    name: 'home',
    components: {
        MainScreen,
        OBD,
        DualCamera,
        SingleCamera
    },
    data() {
        return {
            showType: 0
        };
    },
    mounted() {},
    methods: {
        switchType(type) {
            this.showType = type;
        }
    }
};
</script>
<style lang="less" scoped>
.visualization {
    width: 100%;
    height: 100%;
    min-width: 1200px;
    // padding: 0.2rem;
    overflow: hidden;
    background: linear-gradient(180deg, #001530 0%, #071b46 100%);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    color: #fff;
}
</style>